import styled from 'styled-components';
import { Flex } from '../layout/Flex';

export const HeaderContainer = styled(Flex)
    .withConfig({ displayName: 'CollectionHeaderContainer' })
    .attrs({
        direction: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        pt: 2,
        pb: 1.5,
        backgroundColor: 'var(--background-primary-blur)',
    })``;

export const HeaderContent = styled(Flex)
    .withConfig({ displayName: 'CollectionHeaderContent' })
    .attrs({
        direction: 'row',
        spacing: 1.5,
        height: '100%',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    })``;

export const CenterContent = styled(Flex)
    .withConfig({ displayName: 'CollectionHeaderCenterContent' })
    .attrs({
        direction: 'row',
        mx: 'auto',
        width: 'calc(100% - 120px)',
    })``;

export const InfoColumn = styled(Flex)
    .withConfig({ displayName: 'CollectionHeaderInfoColumn' })
    .attrs({
        direction: 'column',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
    })``;

export const ScrollableHeaderContainer = styled(Flex)
    .withConfig({ displayName: 'CollectionScrollableHeaderContainer' })
    .attrs({
        direction: 'row',
        width: '100%',
        alignItems: 'center',
        pt: 1.5,
        pb: 2,
        px: { xs: 1, sm: 0 },
        backgroundColor: 'transparent',
    })``;

export const ScrollableHeaderContent = styled(Flex)
    .withConfig({ displayName: 'CollectionScrollableHeaderContent' })
    .attrs({
        direction: 'column',
        spacing: 3,
        width: '100%',
    })``;

export const ContentItem = styled(Flex).withConfig({ displayName: 'CollectionContentItem' }).attrs({
    direction: 'row',
    alignItems: 'center',
    spacing: 1.5,
    width: '100%',
})``;

export const AnimatedContent = styled(Flex)
    .withConfig({ displayName: 'CollectionHeaderAnimatedContent' })
    .attrs({
        direction: 'row',
        alignItems: 'center',
        width: 'auto',
        overflow: 'hidden',
    })`
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
`;
